import './styles.scss';

export const LineDivision = () => {
  return <div className="line-division" />;
};
